import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-32 pb-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/85 to-slate-900/70 z-10"></div>
        <img 
          src="https://images.unsplash.com/photo-1512080482556-ea648017576c"
          alt="Professional Auto Body Shop"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-20">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-blue-600/20 backdrop-blur-sm border border-blue-400/30 rounded-full px-4 py-2 mb-6">
            <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
            <span className="text-blue-100 text-sm font-medium">Especialistas em Pintura Automotiva e Náutica</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            {companyInfo.slogan}
          </h1>

          {/* Description */}
          <p className="text-lg md:text-xl text-slate-200 mb-8 leading-relaxed">
            Serviços profissionais de bate chapas, pintura automotiva e náutica em Loulé. 
            Qualidade premium e anos de experiência ao seu serviço.
          </p>

          {/* Features */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
            {[
              'Equipa Especializada',
              'Materiais Premium',
              'Garantia de Qualidade'
            ].map((feature, index) => (
              <div 
                key={index}
                className="flex items-center gap-2 text-white bg-white/10 backdrop-blur-sm rounded-lg px-4 py-3 border border-white/20"
              >
                <CheckCircle className="text-blue-400 flex-shrink-0" size={20} />
                <span className="font-medium">{feature}</span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              onClick={() => scrollToSection('quote')}
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
            >
              Pedir Orçamento Grátis
              <ArrowRight className="ml-2" size={20} />
            </Button>
            <Button 
              onClick={() => scrollToSection('services')}
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-sm border-white/30 text-white hover:bg-white/20 text-lg px-8 py-6"
            >
              Ver Serviços
            </Button>
          </div>

          {/* Contact Info */}
          <div className="mt-12 pt-8 border-t border-white/20">
            <p className="text-slate-300 text-sm mb-2">Ligue já para agendar:</p>
            <a 
              href="tel:+351963241522"
              className="text-2xl md:text-3xl font-bold text-white hover:text-blue-400 transition-colors inline-block"
            >
              +351 963 241 522
            </a>
          </div>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent z-20"></div>
    </section>
  );
};
